// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1d187e07","156":"1099ab86","431":"70573561","489":"6f0bdaee","490":"f114e679","608":"c366e6b1"}[chunkId] + ".chunk.js";
};